import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { PrimaryButton } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { CountDownTimerV2 } from '../../count-down-v2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 16px 12px 14px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  box-sizing: border-box;\n  user-select: none;\n"])));
var CountDownTimerWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin: 14px 0 16px;\n"])));
var StyledTitle = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: #334155;\n"])));
var StyledPrimaryButton = styled(PrimaryButton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  font-weight: 600;\n"])));
export var CountDownElementComponent = function CountDownElementComponent(_ref) {
  var labels = _ref.labels;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(StyledTitle, {
      children: labels.remainingTime
    }), /*#__PURE__*/_jsx(CountDownTimerWrapper, {
      children: /*#__PURE__*/_jsx(CountDownTimerV2, {
        label: labels,
        isDisabled: true,
        variant: "submission"
      })
    }), /*#__PURE__*/_jsx(StyledPrimaryButton, {
      disabled: true,
      children: labels.submit
    })]
  });
};